export default __webpack_public_path__ + "static/hamburger-menu-shop-0ff6d08bf37e5e2d501e109d0afae4ce.jpg";